import { render } from "./ProcessedOrders.vue?vue&type=template&id=7952ba22&scoped=true"
import script from "./ProcessedOrders.vue?vue&type=script&lang=js"
export * from "./ProcessedOrders.vue?vue&type=script&lang=js"

import "./ProcessedOrders.vue?vue&type=style&index=0&id=7952ba22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7952ba22"]])

export default __exports__